export default "__VITE_ASSET__pY5Avb$1__"